import React from 'react';

import Nav from 'react-bootstrap/Nav';
import "./navbar-tab.scss"

const NavbarTab = props => {

    const label = props.label ? props.label : "";
    
    const getTabClassName = (isSelected) => {
        let className = 'tab-link resizeable-tab ';
        if(isSelected) className += 'active'; //Look at active class in global -> has active tab asset
    
        return className;
    }

    const getTabTextClassName = (isSelected) => {
        let className = 'tab-text ';
        className += isSelected ? "tab-enabled" : "tab-disabled";
        return className
    }

    const isDefined = (obj) => {
        if(typeof(obj) !== 'undefined'){
            return true;
        }

        return false;
    }

    return(
        <Nav.Link 
            eventKey={label}  
            className={getTabClassName(props.active ? props.active : "")}
            style = {{ height: '52px', paddingTop: '16px' }}
            onClick = {()=>console.log(JSON.stringify(props))}
            >
                <div className={props.icon ? props.icon : "default-div"}></div>
                <div className={getTabTextClassName(props.active ? props.active : "")}>{label}</div>
                <div className={isDefined(props.tabCount) ? "tab-number resize-number-container" : "" }>
                    <div className={isDefined(props.tabCount) ? "tab-number-inner" : ""}>
                        {isDefined(props.tabCount) ? props.tabCount : ""}
                    </div>
                </div>
        </Nav.Link>
    );


}

export default NavbarTab;